import { fetcher } from 'utils/axios';

/**
 * קובץ ברירת מחדל לכותרת מדיה של תבנית וואטסאפ — נתון שלנו בשרת הנוד (מטא לא
 * שומרת כזה). ממולא מראש בשליחת תבנית בפרונט, וה-API נופל אליו כשלא הועבר קובץ.
 */

export type TemplateDefaultFile = {
  templateName: string;
  language: string | null;
  fileUrl: string;
  fileName: string | null;
  updatedOn?: string;
};

function extractEnvelopeData<T>(response: any): T {
  if (response && typeof response === 'object' && 'data' in response && response.success !== undefined) {
    return response.data as T;
  }
  return response as T;
}

export async function fetchTemplateDefaultFiles(): Promise<TemplateDefaultFile[]> {
  const response = await fetcher('post', ['/api/services/listTemplateDefaultFiles', { data: {} }], 'servernode');
  const data = extractEnvelopeData<{ defaultFiles?: TemplateDefaultFile[] }>(response);
  return Array.isArray(data?.defaultFiles) ? data.defaultFiles : [];
}

export async function saveTemplateDefaultFile(params: {
  templateName: string;
  language?: string | null;
  fileUrl: string;
  fileName?: string | null;
}): Promise<void> {
  await fetcher(
    'post',
    [
      '/api/services/saveTemplateDefaultFile',
      {
        data: {
          templateName: params.templateName,
          ...(params.language ? { language: params.language } : {}),
          fileUrl: params.fileUrl,
          ...(params.fileName ? { fileName: params.fileName } : {}),
        },
      },
    ],
    'servernode',
  );
}

export async function deleteTemplateDefaultFile(params: {
  templateName: string;
  language?: string | null;
}): Promise<void> {
  await fetcher(
    'post',
    [
      '/api/services/deleteTemplateDefaultFile',
      {
        data: {
          templateName: params.templateName,
          ...(params.language ? { language: params.language } : {}),
        },
      },
    ],
    'servernode',
  );
}

/** העלאת הקובץ לאחסון פאנר דרך הנוד — מחזיר קישור ציבורי */
export async function uploadTemplateDefaultFile(file: File): Promise<{ fileUrl: string; fileName: string }> {
  const formData = new FormData();
  formData.append('file', file);
  const response = await fetcher('post', ['/api/services/uploadFile', { data: formData }], 'servernode');
  const data = extractEnvelopeData<{ fileLink?: string; fileName?: string }>(response);
  if (!data?.fileLink) throw new Error('UPLOAD_FAILED');
  return { fileUrl: data.fileLink, fileName: data.fileName || file.name };
}
